// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__1LQ94","icon":"SearchBar_icon__3Z3bs"};